<template>
  <div>
    <div v-if="!contracts.length">
      <div class="no-contract-message">There are no contracts to show.</div>
      <div class="align-right">
        <b-button v-if="canViewContractDetails()" :to="{ name: 'contractAdd' }"
          ><font-awesome-icon icon="plus" /> Create Contract</b-button
        >
      </div>
    </div>
    <div v-if="contracts.length">
      <table-widget
        :items="contracts"
        :perPage="perPage"
        :totalRows="totalRows"
        :current-page.sync="currentPage"
        :filter.sync="filter"
      >
        <template slot="content">
          <b-table
            striped
            :items="contracts"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
            small
          >
            <template slot="startTerm" slot-scope="data">
              {{ data.item.termStart ? data.item.termStart.description : "" }}
            </template>
            <template slot="endTerm" slot-scope="data">
              {{ data.item.termEnd ? data.item.termEnd.description : "" }}
            </template>
            <template slot="agreementType" slot-scope="data">
              {{
                data.item.contractAgreementType
                  ? data.item.contractAgreementType.name
                  : ""
              }}
            </template>
            <template slot="stage" slot-scope="data">
              {{ data.item.currentContractStage.name }}
            </template>
            <template slot="status" slot-scope="data">
              {{ data.item.currentContractStatus.name }}
            </template>
            <template slot="details" slot-scope="data">
              <router-link
                :to="{ name: 'contract', params: { id: data.item.contractId } }"
                >Details</router-link
              >
            </template>
          </b-table>
        </template>
      </table-widget>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import TableWidget from "../table-widget";
import roleChecks from "../../misc/role-checks";

export default {
  mixins: [roleChecks],
  data() {
    return {
      fields: [
        { key: "name" },
        { key: "legalName" },
        { key: "startTerm" },
        { key: "endTerm" },
        { key: "agreementType" },
        { key: "stage" },
        { key: "status" },
        { key: "details", label: "" },
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
    };
  },

  components: {
    "table-widget": TableWidget,
  },

  props: {
    contracts: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  watch: {
    contracts: function () {
      this.totalRows = this.contracts.length;
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    canViewContractDetails() {
      return this.isContractManager || this.isContractViewer;
    },
  },

  created() {
    // fields are different depending on user roles
    if (!this.canViewContractDetails()) {
      _.remove(this.fields, function (field) {
        return field.key === "details";
      });
    }
  },
};
</script>

<style scoped>
.align-right {
  text-align: right;
}
</style>
